import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export interface Props {
  markdown: string;
}

const MarkdownRenderer: React.FC<Props> = ({ markdown }) => {
  return <Markdown remarkPlugins={[remarkGfm]}>{markdown}</Markdown>;
};

export default MarkdownRenderer;
